import { Components, Theme } from '@mui/material'

export const MuiCard: Components<Omit<Theme, 'components'>>['MuiCard'] = {}

export const MuiCardHeader: Components<Omit<Theme, 'components'>>['MuiCardHeader'] = {
  styleOverrides: {
    subheader: ({ theme }) => ({
      color: theme.palette.text.muted,
    }),
  },
}

export const MuiCardContent: Components<Omit<Theme, 'components'>>['MuiCardContent'] = {}

export const MuiCardActions: Components<Omit<Theme, 'components'>>['MuiCardActions'] = {}

export const MuiCardActionArea: Components<Omit<Theme, 'components'>>['MuiCardActionArea'] = {}

export const MuiCardMedia: Components<Omit<Theme, 'components'>>['MuiCardMedia'] = {}
